import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { UseFormGetValues } from 'react-hook-form';

import { REOPEN_ID } from '../constants';
import { LocationState, TFormValues } from '../types';

import axiosInstance from '../../../../api/axiosInstance';
import query from '../../../../api/constants.api';

type TProps = {
    setShowFeedbackModal: (val: boolean) => void;
    getValues: UseFormGetValues<TFormValues>;
};

const useReopenIncident = ({ setShowFeedbackModal, getValues }: TProps) => {
    const { state } = useLocation() as LocationState;

    const reopenIncident = () => {
        const comments = getValues(REOPEN_ID);
        const body = {
            //state: '14', // Transferred
            state: '2', // Transferred
            comments: comments,
        };

        return axiosInstance('PUT', `${query.path.incident}/${state.incidentId}`, body, null, 'application/json');
    };

    return useQuery('reopen-incident', reopenIncident, {
        enabled: false,
        onSuccess: () => setShowFeedbackModal(true),
        onError: () => setShowFeedbackModal(true),
    });
};

export default useReopenIncident;